let exploreNav = document.querySelector('[explore-nav]');
let exploreNavMobile = document.querySelector('[explore-nav-mobile]');
const exploreNavButton = exploreNav?.querySelector('[explore-nav-button]');
const exploreNavMenu = exploreNav?.querySelector('[explore-nav-menu]');
const exploreNavButtonMobile = exploreNavMobile?.querySelector('[explore-nav-button]');
const exploreNavMenuMobile = exploreNavMobile?.querySelector('[explore-nav-menu]');

export function utilityNav() {
    if (exploreNav || exploreNavMobile) {
        document.addEventListener('click', (e) => {
            const target = e.target as any;
            if (!target.closest('[explore-nav-button]') && !target.closest('[explore-nav-menu]')) {
                toggleMenuNav(exploreNavButton, exploreNavMenu, true);
                toggleMenuNav(exploreNavButtonMobile, exploreNavMenuMobile, true);
            }
        },
            false
        );
    }

    if (exploreNav) {
        if (exploreNavButton && exploreNavMenu ) {
            exploreNavButton.addEventListener('click', toggleUtilityNav);
           
            }
    }
    if (exploreNavMobile) {
       
        if (exploreNavButtonMobile && exploreNavMenuMobile) {
            exploreNavButtonMobile.addEventListener('click', toggleUtilityNav);
        }
    }
}

function toggleUtilityNav() {
        toggleMenuNav(exploreNavButton, exploreNavMenu, false);
        toggleMenuNav(exploreNavButtonMobile, exploreNavMenuMobile, false);
}

const popupCartMenu = document.querySelector('[data-cart-popup]');
const popupCartButton = document.querySelector('[data-cart-popup-button]');
const popupCartButtonClose = document.querySelector('[data-cart-popup-button-close]');
const popupCartMenuMobile = document.querySelector('[data-cart-popup-mobile]');
const popupCartButtonMobile = document.querySelector('[data-cart-popup-button-mobile]'); 
const popupCartButtonCloseMobile = document.querySelector('[data-cart-popup-button-close-mobile]'); 



export function popupCartNav() {
    if (popupCartMenu || popupCartMenuMobile) {
        document.addEventListener('click', (e) => {
            const target = e.target as any;
            if (!target.closest('[data-cart-popup-button]') && !target.closest('[data-cart-popup]') && !target.closest('[data-cart-popup-button-mobile]') && !target.closest('[data-cart-popup-mobile]')) {
                toggleMenuNav(popupCartButton, popupCartMenu, true);
                toggleMenuNav(popupCartButtonMobile, popupCartMenuMobile, true);
            }
        },
            false
        );
    }

    if (popupCartMenu && popupCartButton) {
        popupCartButton.addEventListener('click', togglePopupCartNav);
        
    }
    if (popupCartButtonClose) {
        popupCartButtonClose.addEventListener('click', togglePopupCartNav);
    }

    if (popupCartMenuMobile && popupCartButtonMobile) {
        popupCartButtonMobile.addEventListener('click', togglePopupCartNav);
    }
    if (popupCartButtonCloseMobile) {
        popupCartButtonCloseMobile.addEventListener('click', togglePopupCartNav);
    }
}
export function togglePopupCartNav(validationMessages = null) {
    if (popupCartMenu.getAttribute('aria-hidden') == 'true') {
        const cartPopup = document.querySelector("[data-cart-popup]");
        const cartPopupMobile = document.querySelector("[data-cart-popup-mobile]");
        if (cartPopup) {
            cartPopupData(null, cartPopup, true, false, validationMessages)
        }
        if (cartPopupMobile) {
            cartPopupData(null, cartPopupMobile, true, false, validationMessages)
        }
        toggleMenuNav(popupCartButton, popupCartMenu, false);
        toggleMenuNav(popupCartButtonMobile, popupCartMenuMobile, false);
        cartPopupUpdate(false, validationMessages);
    }
    else {
        toggleMenuNav(popupCartButton, popupCartMenu, false);
        toggleMenuNav(popupCartButtonMobile, popupCartMenuMobile, false);
    }
}


function toggleMenuNav(button, menu, close) {
    if (close || menu.getAttribute('aria-hidden') == 'false') {
        setAttributeData(button, 'aria-expanded', 'false');
        setAttributeData(menu, 'aria-hidden', 'true');
    }
    else {
            setAttributeData(button, 'aria-expanded', 'true');
            setAttributeData(menu, 'aria-hidden', 'false');
    } 
}

function setAttributeData(el, attribute, data) {
    el.setAttribute(attribute, data);
}



async function fetchCartInfo() {
    const response = await fetch('/api/v1/cartservice/cartinfo');
    const cartData = await response.json();
    return cartData;
}

async function fetchClearCart() {
    const response = await fetch('/api/v1/cartservice/clearCart', {
        method: "POST",
        body: null
    });
    const result = await response.json();
    return result;
}

export const cartPopupUpdate = (init, validationMessages = null) => {
    
    fetchCartInfo().then(cartJsonData => {
    const cartPopup = document.querySelector("[data-cart-popup]");
    const cartPopupMobile = document.querySelector("[data-cart-popup-mobile]");
    if (cartPopup) {
            cartPopupData(cartJsonData, cartPopup, false, init, validationMessages)
        }
        if (cartPopupMobile) {
            cartPopupData(cartJsonData, cartPopupMobile, false, init, validationMessages)
        }
    });
}
function cartPopupData(cartJsonData, cartPopupEl, isLoading, pageLoad, validationMessages = null) {
    const cartPopupCart = cartPopupEl.querySelector("[data-cart-popup-cart]");
    const cartPopupSubtotal = cartPopupEl.querySelector("[data-cart-popup-subtotal]");
    const cartPopupItemNumber = cartPopupEl.querySelector("[data-cart-popup-item-number]");
    const cartPopupOverflow = cartPopupEl.querySelector("[data-cart-popup-overflow]");
    const cartPopupItems = cartPopupEl.querySelector("[data-cart-popup-items]");
    const cartPopupEmpty = cartPopupEl.querySelector("[data-cart-popup-empty]");
    const cartPopupLoading = cartPopupEl.querySelector("[data-cart-popup-loading");
    let cartHtml = '';
    const utilityNavAmount = document.querySelector("[data-cart-amount]");
    const utilityNavAmountMobile = document.querySelector("[data-cart-amount-mobile]");
    const cartValidationMessages = cartPopupEl.querySelector("[data-cart-validation-messages]");

    if (isLoading) {
        cartPopupEl.classList.remove('has-items');
        cartHtml = '';
        cartPopupItems.innerHTML = cartHtml;
        cartPopupItemNumber.innerHTML = "";
        cartPopupCart.classList.remove('active');
        cartPopupEmpty.classList.remove('active');
        cartPopupLoading.classList.add('active');
        utilityNavAmount.classList.add('hidden');
        utilityNavAmountMobile.classList.add('hidden');
    }
    else if (cartJsonData && cartJsonData.cartProducts.length > 0) {
        let cartQuantityShowing = 0;
        let cartProductsTotal = cartJsonData.cartProducts.reduce((sum, item) => sum + item.quantity, 0);
        utilityNavAmount.innerHTML = `${cartProductsTotal}`;
        utilityNavAmount.classList.remove('hidden');
        utilityNavAmountMobile.innerHTML = `${cartProductsTotal}`;
        utilityNavAmountMobile.classList.remove('hidden');
        let sortFinalItems = cartJsonData.cartProducts.sort((a, b) => a.lineItemId - b.lineItemId).reverse().slice(0, 2);
        sortFinalItems.forEach(cartItem => {
            let cartItemTags = '';
            cartItem.tags.forEach(tag => { cartItemTags += `<p class="cart-item-tag">${tag}</p>` });
            let cartItemPrice = `<span class="popup-cart-info-price text-center paragraph-large margin-bottom-zero">$${parseFloat(cartItem.retailPrice).toFixed(2)}/ea</span>`;
            if (cartItem.showYourPrice) {
                cartItemPrice = `<span class="popup-cart-info-price text-center paragraph-large margin-bottom-zero">$${parseFloat(cartItem.yourPrice).toFixed(2)}/ea</span>`;
            }
            cartQuantityShowing += cartItem.quantity;
            cartHtml += `<div class="popup-cart-item">
                            <div class="popup-cart-grid">
                                <a class="popup-cart-item-image-link" href="${cartItem.productUrl}"><img class="popup-cart-item-image" src="${cartItem.imageUrl}"></a>
                                <div class="popup-cart-item-content">
                                    <h4 class="h5-styled">${cartItem.displayName}</h4>
                                    ${cartItemTags}
                                    ${cartItem.quantity > 1 ? cartItemPrice : ''}
                                    <div class="popup-cart-info"><span class="popup-cart-info-quantity text-center paragraph-large margin-bottom-zero">Quantity: ${cartItem.quantity}</span><span class="popup-cart-info-total text-center paragraph-large margin-bottom-zero">$${parseFloat(cartItem.lineItemTotal).toFixed(2)}</span></div>
                                </div>
                            </div>
                        </div>`;
        });
        cartPopupEl.classList.add('has-items');
        cartPopupItems.innerHTML = cartHtml;
        cartPopupOverflow.innerHTML = `<p>${cartProductsTotal - cartQuantityShowing} additional items in cart</p>`;
        if (cartProductsTotal - cartQuantityShowing == 0) {
            cartPopupOverflow.classList.add('hidden');
        } else {
            cartPopupOverflow.classList.remove('hidden');
        }
        cartPopupSubtotal.innerHTML = `$${parseFloat(cartJsonData.total.amount).toFixed(2)}`;
        if (cartProductsTotal == 1) {
            cartPopupItemNumber.innerHTML = `${cartProductsTotal} item`;
        } else {
            cartPopupItemNumber.innerHTML = `${cartProductsTotal} items`;
        }

        if (validationMessages && validationMessages.length > 0) {
            var validationMessagesString = validationMessages.join(',');
            var innerWarning = `<div><svg><use xlink:href="#icon-warning"></use></svg></div><p>${validationMessagesString}</p>`
            cartValidationMessages.classList.add('active');
            cartValidationMessages.innerHTML = innerWarning;
        }
        else {
            cartValidationMessages.classList.remove('active');
        }

        cartPopupEmpty.classList.remove('active');
        cartPopupLoading.classList.remove('active');
        cartPopupCart.classList.add('active');
    }
    else {
        utilityNavAmount.innerHTML = "";
        utilityNavAmount.classList.add('hidden');
        utilityNavAmountMobile.innerHTML = "";
        utilityNavAmountMobile.classList.add('hidden');
        cartPopupEl.classList.remove('has-items');
        cartHtml = '';
        cartPopupItems.innerHTML = cartHtml;
        cartPopupItemNumber.innerHTML = "";

        if (validationMessages && validationMessages.length > 0) {
            var validationMessagesString = validationMessages.join(',');
            var innerWarning = `<div><svg><use xlink:href="#icon-warning"></use></svg></div><p>${validationMessagesString}</p>`
            cartValidationMessages.classList.add('active');
            cartValidationMessages.innerHTML = innerWarning;
        }
        else {
            cartValidationMessages.classList.remove('active');
        }

        cartPopupCart.classList.remove('active');
        cartPopupLoading.classList.remove('active');
        cartPopupEmpty.classList.add('active');
    }
}

    export const clearCartUpdate = () => {
        const cartPopup = document.querySelector("[data-cart-popup]");
        const cartPopupMobile = document.querySelector("[data-cart-popup-mobile]");

        //Set loading spinner
        if (cartPopup) {
            cartPopupData(null, cartPopup, true, false)
        }
        if (cartPopupMobile) {
            cartPopupData(null, cartPopupMobile, true, false)
        }

        fetchClearCart().then(response => {
            //Remove loading spinner and set empty cart display in pop up.
            const cartPopup = document.querySelector("[data-cart-popup]");
            const cartPopupMobile = document.querySelector("[data-cart-popup-mobile]");
            if (cartPopup) {
                cartPopupData(null, cartPopup, false, false)
            }
            if (cartPopupMobile) {
                cartPopupData(null, cartPopupMobile, false, false)
            }
    });
}
export function initPopupCart() {
    cartPopupUpdate(true);
}
export function popupCartNavClearCart() {
    let clearCartCta = document.getElementById("cart-popup-clear-cart-cta") as HTMLButtonElement;
    let clearCartCtaMobile = document.getElementById("cart-popup-clear-cart-cta-mobile") as HTMLButtonElement;

    if (clearCartCta || clearCartCtaMobile) {
        document.addEventListener('click', (e) => {
            const target = e.target as any;
            if (target.id === 'cart-popup-clear-cart-cta'
                || target.id === 'cart-popup-clear-cart-cta-mobile') {
                clearCartUpdate();
            }
        })
    }
}

export function disablePopUpCartCheckoutCta() {
    let checkoutCta = document.getElementById("cart-popup-checkout-cta") as HTMLButtonElement;
    let checkoutCtaMobile = document.getElementById("cart-popup-checkout-cta-mobile") as HTMLButtonElement;

    if (checkoutCta || checkoutCtaMobile) {
        document.addEventListener('click', (e) => {
            const target = e.target as any;
            if (target.id === 'cart-popup-checkout-cta'
                || target.id === 'cart-popup-checkout-cta-mobile') {
                if (checkoutCta) {
                    checkoutCta.className = "button-primary button-primary-disabled";
                }
                if (checkoutCtaMobile) {
                    checkoutCtaMobile.className = "button-primary button-primary-disabled";
                }
            }
        })
    }
}